export const saleRibbonOptions = {
  SALE: 'sale',
  X_PERCENT_OFF: 'x%Off',
  SAVE_X_PERCENT: 'saveX%'
};

export const bestsellerRibbonOptions = {
  BESTSELLER: 'bestseller',
  HOT_ITEM: 'hotItem',
  TOP_PICK: 'topPick'
};

export const newProductRibbonOptions = {
  NEW: 'new',
  NEW_ARRIVAL: 'newArrival'
};

export const styleOptions = {
  DEFAULT: 'default',
  TRANSPARENT: 'transparent',
  ROUND_RECTANGLE: 'roundRectangle',
  PILL: 'pill'
};
